'use client'

import { NextPage } from 'next'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'
import { LoadingBackdrop } from '~/components/LoadingBackdrop'

type Props = {
  params: { id: string }
}

const Page: NextPage<Props> = ({ params }) => {
  const { push } = useRouter()

  useEffect(() => {
    push(`/videos/${params.id}/play`)
  }, [params, push])

  return <LoadingBackdrop />
}

export default Page
